module.exports = __webpack_public_path__ + "static/media/buildingConstruction10.635c04d4.jpg";